import React, { useState } from "react";
import moment from "moment";
import { Modal, ModalBody, ModalHeader, Button, ModalFooter } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import "../styles/reportsStyles.scss"
import { AiFillCaretDown } from 'react-icons/ai'
import { setDateRange, loadReserveParachuteExpiryDates } from "../redux/actions/reportActions";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import LoadingComponent from "../components/LoadingComponent";
import ListEmptyComponent from "../components/ListEmptyComponent";
import { isEmpty } from "lodash";
import XLSX from 'sheetjs-style'

export default function ReportsReserveParachuteExpiryDates() {

	const [modal, setModal] = useState(false);
	const toggle = () => setModal(!modal);

	const { startDate, endDate, reserveParachuteList, loading } = useSelector(state => state.reportReducer);
	const dispatch = useDispatch()

	const handleOnClickOpenModal = () => toggle()

	const handleOnChangeDates = (item) => {
		dispatch(setDateRange({ dateRange: item.selection }))
	}

	const handleOnClickUpdate = () => {
		dispatch(loadReserveParachuteExpiryDates())
	}

	const exportToExcel = async () => {
		const worksheet = XLSX.utils.json_to_sheet(reserveParachuteList.map(parachute=>({
			"Attached To": parachute.attachedTo,
			"Reserve Parachute ID": parachute.componentCustomID,
			"End of Life": moment(parachute.endOfLife).format("DD MMM yyyy"),
			"Next Service Due Date": moment(parachute.nextServiceDueDate).format("DD MMM yyyy")
		})));
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Reserve Parachute Expiry Dates");
		XLSX.writeFile(workbook, `reserve-parachute-expiry-dates.xlsx`)
	}

	return (
		<div>
			<div class="header-row">
				<div className="header-container date-range-container">
					<label ><strong> DateRange: </strong></label>
					<div className="date-text left">
						{moment(startDate).format("DD MMM yyyy")}
					</div>
					<div className="date-text right">
						{moment(endDate).format("DD MMM yyyy")}
					</div>
					<button className="down-arrow" onClick={handleOnClickOpenModal}>
						<AiFillCaretDown size={25} />
					</button>
				</div>
				<div className="header-container">
					<Button color="danger" onClick={handleOnClickUpdate}>
						Update
					</Button>
				</div>
				<div className="header-container">
					<Button color="danger" onClick={exportToExcel} disabled={reserveParachuteList.length == 0}>
						Export
					</Button>
				</div>
			</div>
			{loading && <LoadingComponent />}
			{!loading && isEmpty(reserveParachuteList) && <ListEmptyComponent />}
			{!loading && !isEmpty(reserveParachuteList) &&
				<div className="data-table">
					<table class="table table-striped" borderless>
						<thead>
							<tr>
								<th scope="col">
									Attached To
								</th>
								<th scope="col">
									Reserve Parachute ID
								</th>
								<th scope="col">
									End of Life
								</th>
								<th scope="col">
									Next Service Due Date
								</th>
							</tr>
						</thead>
						<tbody>
							{
								reserveParachuteList.map(parachute => (
									<tr>
										<td>
											{parachute.attachedTo}
										</td>
										<td>
											{parachute.componentCustomID}
										</td>
										<td>
											{moment(parachute.endOfLife).format("DD MMM yyyy")}
										</td>
										<td>
											{moment(parachute.nextServiceDueDate).format("DD MMM yyyy")}
										</td>
									</tr>
								))
							}
						</tbody>
					</table>
				</div>
			}

			<Modal isOpen={modal} toggle={toggle} size="lg">
				<ModalHeader toggle={toggle}>Select Date Range</ModalHeader>
				<ModalBody style={{
					display: 'flex',
					justifyContent: 'center'
				}}>

					<DateRangePicker
						onChange={handleOnChangeDates}
						showSelectionPreview={true}
						moveRangeOnFirstSelection={false}
						months={1}
						ranges={[{
							startDate,
							endDate,
							key: 'selection'
						}]}
						direction="horizontal"
						scroll={{ enabled: true }}
					/>
				</ModalBody>
				<ModalFooter>
					<Button onClick={toggle}>Done</Button>
				</ModalFooter>
			</Modal>
		</div >
	);
}
